import {
  ContractorPayment,
  createContractorPaymentSchema,
  zSchema,
} from "@zeal/common";
import axiosLib from "axios";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

export type TCreateContractorPaymentRequest = zSchema.infer<
  typeof createContractorPaymentSchema
>;

type TCreateContractorPaymentResponse = IApiResponse<ContractorPayment> & {
  readonly errors?: ReadonlyArray<{ readonly message?: string }>;
};

const getCreateContractorPaymentErrorMessage = (
  data: unknown
): string | undefined => {
  if (typeof data !== "object" || data === null) {
    return undefined;
  }
  const errors = (data as { errors?: ReadonlyArray<{ message?: string }> })
    .errors;
  return errors?.[0]?.message;
};

export const createContractorPayment = (axios: IAxiosInstance) => {
  return async (requestBody: TCreateContractorPaymentRequest) => {
    try {
      const response =
        await axios.noRetry.post<TCreateContractorPaymentResponse>(
          "api/contractorPayment",
          requestBody
        );
      const resData = response.data;

      if (resData.success) {
        return resData.data;
      }

      const message =
        getCreateContractorPaymentErrorMessage(resData) ??
        "Something went wrong";
      throw new Error(message);
    } catch (e: unknown) {
      if (axiosLib.isAxiosError(e)) {
        const fromBody = getCreateContractorPaymentErrorMessage(
          e.response?.data
        );
        if (fromBody) {
          throw new Error(fromBody);
        }
      }
      throw e;
    }
  };
};
